import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Skeleton,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useMemo } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { axios } from "../../../../../utils/useAxios";
import { STATUS } from "../constants/status.constant";
import { useHardPromotionFormMutate } from "../contexts/hard-promotion-form.context";
import SelectOption from "../../../../../components/SelectOption";
import {
  PROMOTION_TYPE_OPTIONS,
  PROMOTION_CONDITION_TYPE_OPTIONS,
} from "../constants/type.constant";

const FormHardPromotion = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const {
    state: { loading, data },
    dispatch,
  } = useHardPromotionFormMutate();
  const promotion_id = useMemo(() => match.params.id, [match.params.id]);

  // let data_ratio = {
  //   condition_amount: 1,
  //   receive_qty: 1,
  // };
  const getDataCallback = useCallback(async () => {
    if (promotion_id && promotion_id !== "new") {
      dispatch({ type: "LOAD_DATA" });
      try {
        const { data } = await axios.get(
          `/marketing/hard-promotion/${promotion_id}`,
        );
        // if (!data.condition_amount) {
        //   data_ratio = calRatio(data.ratio || 0);
        // } else {
        //   data_ratio = {
        //     condition_amount: data.condition_amount,
        //     receive_qty: data.receive_qty,
        //   };
        // }
        dispatch({
          type: "LOAD_DATA_SUCCESS",
          payload: {
            ...data,
            start_date: data?.start_date ? moment(data?.start_date) : null,
            end_date: data?.end_date ? moment(data?.end_date) : null,
            // ...data_ratio,
          },
        });
      } catch (error) {
        dispatch({ type: "LOAD_DATA_FAIL" });
      }
    }
  }, [promotion_id, dispatch]);

  const setFormValue = (payload) => {
    dispatch({ type: "SET_DATA", payload });
  };

  // const calRatio = (value) => {
  //   let condition_amount = null;
  //   let receive_qty = null;
  //   if (value && value > 0) {
  //     condition_amount = 1;
  //     receive_qty = 1;
  //     if (value < 1) {
  //       condition_amount = receive_qty / value;
  //     } else {
  //       receive_qty = condition_amount * value;
  //     }
  //   }
  //   return {
  //     condition_amount: parseInt(condition_amount),
  //     receive_qty: parseInt(receive_qty),
  //   };
  // };

  const submit = () => {
    if (!data.name?.trim().length)
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "โปรดระบุชื่อโปรโมชัน",
      });
    if (!data?.start_date)
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "โปรดระบุวันที่เริ่มต้น",
      });
    if (!data?.end_date)
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "โปรดระบุวันที่สิ้นสุด",
      });
    if (!data.type?.trim().length)
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "โปรดระบุประเภทโปรโมชัน",
      });
    if (!data.condition_type?.trim().length)
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "โปรดระบุเงื่อนไขของโปรโมชัน",
      });
    if (!data.items.length && data.condition_type == "item")
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "รายการสินค้าในเงื่อนไขต้องมีอย่างน้อย 1 รายการ",
      });
    if (!data.free.length)
      return notification.warning({
        message: "กรุณาตรวจสอบข้อมูล",
        description: "รายการสินค้าแถมต้องมีอย่างน้อย 1 รายการ",
      });

    Modal.confirm({
      title: "บันทึก",
      content: "ต้องการบันทึกโปรโมชันหรือไม่",
      okText: "บันทึก",
      cancelText: "ยกเลิก",
      onOk: async () => {
        return new Promise(async (resolve, reject) => {
          try {
            const payload = {
              ...data,
              name: data.name?.trim(),
              start_date: data.start_date ? data.start_date.toDate() : null,
              end_date: data.end_date ? data.end_date.toDate() : null,
            };

            let url = "/marketing/hard-promotion";
            if (data.id) url += `/${data.id}`;

            await axios.post(url, payload);

            resolve("");
          } catch (error) {
            reject(error.response?.data?.message || error.message);
          }
        })
          .then((res) => {
            Modal.success({
              title: "สำเร็จ",
              content: "บันทึกข้อมูลเรียบร้อย",
              okText: "ปิด",
              onOk: () => history.goBack(),
            });
          })
          .catch((reason) => {
            Modal.error({
              title: "ผิดพลาด",
              content: reason,
              okText: "ปิด",
            });
          });
      },
    });
  };

  useEffect(() => {
    getDataCallback();
  }, [getDataCallback]);

  if (loading) return <Skeleton />;

  return (
    <Form layout="horizontal">
      <Row gutter={16}>
        <Col md={24} className="text-right">
          <Button type="primary" onClick={submit}>
            บันทึก
          </Button>
        </Col>
      </Row>

      <Row gutter={16} className="mb-2 d-flex align-items-center">
        <Col md={3} className="text-right">
          <Typography.Text>รหัส:</Typography.Text>
        </Col>
        <Col md={5}>
          <Input placeholder="รหัสโปรโมชัน" value={data.code} disabled />
        </Col>
      </Row>
      <Row gutter={16} className="mb-2 d-flex align-items-center">
        <Col md={3} className="text-right">
          <Typography.Text>ชื่อ:</Typography.Text>
        </Col>
        <Col md={13}>
          <Input
            placeholder="ชื่อโปรโมชัน แสดงผลในหน้าระบบ Member"
            value={data.name}
            onChange={(e) => setFormValue({ name: e.target.value })}
          />
        </Col>
      </Row>
      <Row gutter={16} className="mb-2 d-flex align-items-center">
        <Col md={3} className="text-right">
          <Typography.Text>เริ่มต้น:</Typography.Text>
        </Col>
        <Col md={5}>
          <DatePicker
            placeholder="วันที่เริ่มต้นโปรโมชัน"
            showTime={{
              defaultValue: moment(
                moment().startOf("date").format("HH:mm:ss"),
                "HH:mm:ss",
              ),
            }}
            showToday={false}
            value={data.start_date}
            defaultValue={moment().startOf("date")}
            format={"DD/MM/YYYY HH:mm:ss"}
            onChange={(start_date) => setFormValue({ start_date })}
            disabledDate={(current) => {
              return data.end_date && current > data.end_date;
            }}
          />
        </Col>
        <Col md={3} className="text-right">
          <Typography.Text>สิ้นสุด:</Typography.Text>
        </Col>
        <Col md={5}>
          <DatePicker
            placeholder="วันที่สิ้นสุดโปรโมชัน"
            showTime={{
              defaultValue: moment(
                moment().endOf("date").format("HH:mm:ss"),
                "HH:mm:ss",
              ),
            }}
            showToday={false}
            value={data.end_date}
            defaultValue={moment().endOf("date")}
            format={"DD/MM/YYYY HH:mm:ss"}
            onChange={(end_date) => setFormValue({ end_date })}
            disabledDate={(current) => {
              return data.start_date && current < data.start_date;
            }}
          />
        </Col>
      </Row>
      <Row gutter={16} className="mb-2 d-flex align-items-center">
        <Col md={3} className="text-right">
          <Typography.Text>ประเภท:</Typography.Text>
        </Col>
        <Col md={3}>
          <SelectOption
            value={data.type}
            data={PROMOTION_TYPE_OPTIONS}
            withAll
            allText="เลือกประเภท"
            className="w-full"
            onChange={(value) => setFormValue({ type: value })}
          />
        </Col>
        <Col md={1} className="text-right">
          <Typography.Text>เงื่อนไข:</Typography.Text>
        </Col>
        <Col md={3}>
          <SelectOption
            value={data.condition_type}
            data={PROMOTION_CONDITION_TYPE_OPTIONS}
            withAll
            allText="เลือกเงื่อนไข"
            className="w-full"
            onChange={(value) => setFormValue({ condition_type: value })}
          />
        </Col>
        <Col md={2} className="text-right">
          <Typography.Text>จำนวนที่ต้องซื้อ :</Typography.Text>
        </Col>
        <Col md={6}>
          <Input.Group>
            <Row gutter={8} className="d-flex align-items-center">
              <Col span={6}>
                <InputNumber
                  min={1}
                  step={1}
                  value={data.condition_amount}
                  onChange={(value) =>
                    setFormValue({
                      condition_amount: value,
                    })
                  }
                />
              </Col>
              <Col span={10} className="text-center">
                <Typography.Text>จำนวนสิทธิ์ที่ได้รับ :</Typography.Text>
              </Col>
              <Col span={6}>
                <InputNumber
                  min={1}
                  step={1}
                  value={data.receive_qty}
                  onChange={(value) =>
                    setFormValue({
                      receive_qty: value,
                    })
                  }
                />
              </Col>
            </Row>
          </Input.Group>

          {/* <Input
            placeholder="อัตราส่วน"
            value={data.ratio}
            onChange={(e) => {
              const value = e.target.value;
              const ratio = value
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*)\./g, "$1");
              setFormValue({ ratio });
            }}
            addonAfter={
              <Tooltip title={`อัตราส่วน เงื่อนไข : ได้รับ`}>
                {calRatio(parseFloat(data.ratio))}
              </Tooltip>
            }
          /> */}
        </Col>
        <Col md={2} className="text-right">
          <Typography.Text>แสดงผล:</Typography.Text>
        </Col>
        <Col md={4}>
          <Switch
            defaultChecked={data.status === STATUS.ACTIVE}
            onChange={(checked) => {
              setFormValue({
                status: checked ? STATUS.ACTIVE : STATUS.IN_ACTIVE,
              });
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default FormHardPromotion;
